import axios from 'axios'
import React from 'react'

import { CostsBreakdown } from '@components/common/CostsBreakdown'
import { Loader, ModalBox, Toasts, useModalContext } from '@fourthwall/components'
import { errorMessageSelector } from '@fourthwall/utils/dist/selectors'

import { useCostsBreakdownQuery } from './hooks/useCostsBreakdownQuery'

type DonationCostsBreakdownModalProps = {
  donationId: string
}

export const DonationCostsBreakdownModal = ({ donationId }: DonationCostsBreakdownModalProps) => {
  const { close } = useModalContext()

  const { donationCostsBreakdownQuery } = useCostsBreakdownQuery([donationId], {
    onError: (error: unknown) => {
      if (axios.isAxiosError(error)) {
        const errorMessage = errorMessageSelector(
          error.response?.data,
          'Failed to fetch costs breakdown. Please try again.',
        )
        Toasts.notify(errorMessage, { type: 'error' })
      }

      close()
    },
  })

  const renderContent = () => {
    if (!donationCostsBreakdownQuery.data) {
      return (
        <div
          style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Loader size="large" />
        </div>
      )
    }

    return <CostsBreakdown costsBreakdown={donationCostsBreakdownQuery.data} />
  }

  return (
    <ModalBox title="Costs breakdown" onClose={close}>
      {renderContent()}
    </ModalBox>
  )
}
